import { Component, h, Prop, Host } from "@stencil/core";
import { LoaderVariant } from "@trumpf/ux.ui/dist/types/components";

@Component({
    tag: "ux-w-wrapper",
    styleUrl: "wrapper.scss",
    shadow: false
})
export class Wrapper {
    /** url for the Link next to the title */
    @Prop() url: string = "";
    /** text for the title attribute of the link */
    @Prop() linkTitle: string = "";
    /** text for the title */
    @Prop() headline: string = "";
    /** does this widget have a menu */
    @Prop() hasMenu: boolean = false;
    /** indicate a loading state */
    @Prop() isLoading: boolean = false;

    render() {
        const baseClass = "ux-w-wrapper";

        return (
            <Host class={baseClass}>
                <ux-w-header
                    url={this.url}
                    linkTitle={this.linkTitle}
                    hasMenu={this.hasMenu}
                >
                    <span slot="headline">{this.headline}</span>
                    <div slot="menu">
                        <slot name="menu" />
                    </div>
                </ux-w-header>
                <div class={`${baseClass}__body`}>
                    {this.isLoading && (
                        <div class={`${baseClass}__loader`}>
                            <ux-loader
                                variant={"spinner" as LoaderVariant}
                            ></ux-loader>
                        </div>
                    )}
                    <slot name="content" />
                </div>
            </Host>
        );
    }
}
